import { PracticeRecommendationResponse, PracticeRecommendations } from '../types'
import { getMpAgent } from './utils'

const agent = getMpAgent()

const PATHS = {
  RECOMMENDATIONS: '/field-recommendations',
}

export class FieldRecommendationsAPI {
  static getRecommendation({ resourceId }: PracticeRecommendations, options?: any) {
    return agent
      .post<PracticeRecommendationResponse>(PATHS.RECOMMENDATIONS, { resourceId }, options)
      .then(response => response.data)
  }
}
